
import { Component, ChangeDetectionStrategy, inject, signal, OnInit, computed } from '@angular/core';
import { RouterOutlet, RouterLink } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { AuthService } from '../../services/auth.service';
import { DataService } from '../../services/data.service';
import { DataSourceIndicatorComponent } from '../data-source-indicator/data-source-indicator.component';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { LanguageSwitcherComponent } from '../language-switcher/language-switcher.component';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { TourService } from '../../services/tour.service'; 

@Component({
  selector: 'app-back-office',
  standalone: true,
  templateUrl: './back-office.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SidebarComponent,
    RouterOutlet,
    DataSourceIndicatorComponent,
    ConfirmationModalComponent,
    LanguageSwitcherComponent,
    TranslatePipe,
    RouterLink
  ],
})
export class BackOfficeComponent implements OnInit {
  private authService = inject(AuthService);
  private dataService = inject(DataService);
  private tourService = inject(TourService); 
  
  currentUser = this.authService.currentUser;
  isSupabaseMode = signal<boolean>(false);
  showLogoutConfirm = signal<boolean>(false);
  isMobileMenuOpen = signal(false);

  isOwner = computed(() => this.authService.currentUser()?.role === 'owner');
  isAdmin = computed(() => this.authService.currentUser()?.role === 'admin');

  ngOnInit(): void {
    this.isSupabaseMode.set(this.dataService.isSupabaseEnabled());
  }

  requestLogout(): void {
    this.showLogoutConfirm.set(true);
  }

  handleConfirmLogout(): void {
    this.authService.logout();
  }

  handleCancelLogout(): void {
    this.showLogoutConfirm.set(false);
  }

  startTour(): void {
    this.tourService.startTour();
  }
}
